module.exports = __webpack_public_path__ + "images/5ba5f9cd0c43d9f966774630aa65d7c6.svg";